import { useRef } from 'react';

import { useScrollToEnd } from '@crm/shared/lib';

export const useAddColumn = ({ onAddCb }: { onAddCb: () => void }) => {
    const scrollContainerRef = useRef<HTMLElement>(null);
    const scrollToEnd = useScrollToEnd(scrollContainerRef);

    const handleAddColumnClick = () => {
        onAddCb();
        requestAnimationFrame(scrollToEnd);
    };

    return {
        scrollContainerRef,
        scrollToEnd,
        handleAddColumnClick,
    };
};
